import clsx from "clsx";
import { ReactNode } from "react";
import { twMerge } from "tailwind-merge";
interface MenuDrawerMobileProps {
  children: ReactNode;
  isOpen: boolean;
}

const MenuDrawerMobile = ({ children, isOpen }: MenuDrawerMobileProps) => {
  const stateClasses = clsx({
    "translate-x-0": isOpen,
  });

  const baseDrawerClasses =
    "absolute right-0 left-0 h-full w-dvw top-0 translate-x-full transition-all duration-200 ease-in-out overflow-y-auto overflow-x-hidden bg-fog-00";

  return <div className={twMerge(baseDrawerClasses, stateClasses)}>{children}</div>;
};

export { MenuDrawerMobile };
